import React from "react";

function ProductImageUploader({

    imagePreview,

    handleChange,
    multiple = true,
    errors

}) {

    return (

        <div className="card shadow-sm mb-4">

            <div className="card-header">

                <h5>
                    Product Image
                </h5>
            </div>
            <div className="card-body">
                <input
                    type="file"
                    className={`form-control ${errors.image ? "is-invalid" : ""}`}
                    name="images"
                    accept="image/*"
                    multiple
                    onChange={handleChange}
                />

                <div className="text-center mt-4">
                    {Array.isArray(imagePreview) &&
                        imagePreview.map((img, index) => (
                            <img
                                key={index}
                                src={img}
                                width={120}
                                alt=""
                            />
                        ))
                    }

                </div>

            </div>

        </div>

    );

}

export default ProductImageUploader;